"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var DlgDescriptionEditor = /** @class */ (function (_super) {
    __extends(DlgDescriptionEditor, _super);
    function DlgDescriptionEditor(props) {
        return _super.call(this, props) || this;
    }
    DlgDescriptionEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.title,
                description: data.description
            });
        });
        this.doReSetRules();
    };
    DlgDescriptionEditor.prototype.doReSetRules = function () {
        this.setState({
        // amount_rules: {isError: false },
        });
    };
    DlgDescriptionEditor.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgDescriptionEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        return true;
    };
    DlgDescriptionEditor.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.description);
            }
        }
    };
    DlgDescriptionEditor.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgDescriptionEditor.prototype.onValueChange = function (e) {
        this.setState({ description: e.target.value });
    };
    DlgDescriptionEditor.prototype.render = function () {
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false, okType: "primary", style: { minWidth: 500 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(antd_1.Input, { onChange: this.onValueChange.bind(this), value: this.state.description })));
    };
    return DlgDescriptionEditor;
}(React.Component));
exports.default = DlgDescriptionEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgDescriptionEdit.tsx
// module id = 2047
// module chunks = 0